<template>
	<div>
		<center>loading………………</center>
	</div>
</template>
<script>
	import apiData from "@/config/api";
	import http from "@/config/httpConfig";
	export default {
		components: {
		},
		data() {
			return {
				info: ''
			};
		},
		created() {

		},
		mounted() {
			this.proxyLogin()
		},
		methods: {
			clearAllCookie() {
				var date = new Date();
				date.setTime(date.getTime() - 10000);
				var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
				console.log("需要删除的cookie名字：" + keys);
				if (keys) {
					for (var i = keys.length; i--;)
						document.cookie = keys[i] + "=0; expire=" + date.toGMTString() + "; path=/";
				}
			},
			proxyLogin(to, from, token,next) {
				let _this = this
				http.get('/api/common/organizationstructure/user/proxylogin', true, { HncToken: token ? token : ''}, function (res) {
					console.log(res);
					let data = res.data.data
					$.getJSON(data.askurl + "?callback=?", {
							askData: data.askData,
							HncToken: token ? token : '',
							switchboard_identity_id: '',
							appDomain: data.appDomain,
						},
						function (d) {
							console.log(d)
							if (d.status == false) {
								if ("没有获取到token" == d.msg || "根据token没有获取用户信息" == d.msg) {
									
								} else {
									alert(d.msg);
								}
								_this.clearAllCookie()
								window.location.href = data.redirectLoginUrl;
							} else {
								http.get('/api/common/organizationstructure/user/oklogin', false, {
									token: d.msg,
									HncToken: d.msg,
									switchboard_identity_id: d.obj,
									returnURL: data.returnURL
								}, function (res) {
									if (res.data.status) {
										next()
									} else {
										alert(res.msg);
										window.location.href = res.redirectLogoutUrl;
									}
								})
							}
						})
				})
			}
			
		},
	};
</script>

<style scoped lang="less">
</style>